import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=072c35e8&scoped=true"
import script from "./Uploader.vue?vue&type=script&lang=ts"
export * from "./Uploader.vue?vue&type=script&lang=ts"
import style0 from "./Uploader.vue?vue&type=style&index=0&id=072c35e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c35e8",
  null
  
)

export default component.exports